import React from 'react';
import { Hex } from 'viem';

import { ButtonProps } from '../Button/Button.component';
import { Web3WalletConnectButton } from './components/Connect/Connect.component';

// export { useWeb3 } from './hooks/useWeb3.hook';
// export { useWeb3WalletBalance } from './hooks/useWeb3WalletBalance.hook';
// export { useWeb3TokenBalance } from './hooks/useWeb3TokenBalance.hook';

const Web3Balance = React.lazy(
  () => import(/* webpackChunkName: "Web3Balance" */ './components/Balance/Balance.component'),
);

const Web3Address = React.lazy(
  () => import(/* webpackChunkName: "Web3Address" */ './components/Address/Address.component'),
);
interface IWeb3 {
  Balance: React.FC<React.PropsWithChildren<{ icon?: boolean; className?: string }>>;
  Address: React.FC<
    React.PropsWithChildren<{
      icon?: boolean;
      address?: Hex;
      className?: string;
    }>
  >;
  Connect: React.FC<React.PropsWithChildren<Partial<ButtonProps>>>;
}

const Web3: IWeb3 = {
  Balance: Web3Balance,
  Address: Web3Address,
  Connect: Web3WalletConnectButton,
};

export default Web3;
